/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { SxProps, Theme } from '@mui/material';

export const pdpListPriceDisplaySX: SxProps<Theme> = {
	color: (theme) => theme.palette.text.secondary,
	fontWeight: '400',
	fontSize: 16,
	padding : 0.5,
	lineHeight:1,
};

export const pdpOfferPriceDisplaySX = ({list, offer}:{list:number, offer:number}):SxProps => ({
	fontSize:34,
	color:list === 0 || list===offer? '#000' : 'text.offerPrice', 
	fontWeight:'bold',
	lineHeight:1.2,
})